import {
  ContractDateFilter,
  ContractsProductFilter,
  ContractsStatusFilter,
  EndShipFilter,
  Filter,
  StartShipFilter,
} from "components/Filters";

const contractsFilters: Filter[] = [
  { key: "contractDate", component: ContractDateFilter },
  { key: "product", component: ContractsProductFilter },
  { key: "status", component: ContractsStatusFilter },
  { key: "startShip", component: StartShipFilter },
  { key: "endShip", component: EndShipFilter },
];

export default contractsFilters;
